export function nextMediaName(productName: string, existingNames: string[], maxLength = 50): string {
    const names = new Set(existingNames.map(name => (name || '').trim().toLocaleLowerCase()));
    for (let number = 1; ; number++) {
        const suffix = ' ' + number;
        const candidate = (productName || 'Product').trim().slice(0, maxLength - suffix.length) + suffix;
        if (!names.has(candidate.toLocaleLowerCase())) { return candidate; }
    }
}

export function moveMedia<T>(rows: T[], from: number, to: number): T[] {
    const result = rows.slice();
    if (from < 0 || from >= result.length || to < 0 || to >= result.length) { return result; }
    const moved = result.splice(from, 1)[0];
    result.splice(to, 0, moved);
    return result;
}
